<div
	*ngIf="currentOption && !currentOption.isSelectedInTable && data.rawValue"
	class="icon-container padding-top-10 text-align-center cursor-pointer"
	(click)="onClickFund()"
	[tooltip-dcr]="'FTE_LIGHTBULB_HOVER_TEXT'"
	[tooltip-hover]="true"
	[tooltip-always-show-icon]="true"
>
	<ng-container *ngIf="showIcon">
		<icon class="icon" type="lightbulb"></icon>
	</ng-container>
</div>
<div class="icon-container padding-top-10 text-align-center cursor-pointer" *ngIf="currentOption?.isSelectedInTable && data?.rawValue" (click)="onClickFund()">
	<ng-container *ngIf="showIcon">
		<icon class="icon" type="chevron-up"></icon>
	</ng-container>
</div>
